import {
  DELETE_PLC_SAFETY_TRIGGER,
  DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  DELETE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

const initialState = {
  deletePlcSafetyTriggerError: null,
  messagePlcSafetyTrigger: null,
  loadingDeletePlcSafetyTrigger: false,
};

const deleteTrigger = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PLC_SAFETY_TRIGGER:
      state = { ...state, loadingDeletePlcSafetyTrigger: true, deletePlcSafetyTriggerError: null };
      break;
    case DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL:
      state = {
        ...state,
        loadingDeletePlcSafetyTrigger: false,
        messagePlcSafetyTrigger: action.payload,
        deletePlcSafetyTriggerError: null,
      };
      break;
    case DELETE_PLC_SAFETY_TRIGGER_FAILED:
      state = {
        ...state,
        messagePlcSafetyTrigger: null,
        loadingDeletePlcSafetyTrigger: false,
        deletePlcSafetyTriggerError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteTrigger;
